/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Image, rem } from '@mantine/core';

// Date
import {
	DateInput,
	DatePickerInput,
} from '@mantine/dates';

// Style
import classes from './DatePicker.module.css';

// Icons
import CalendarIcon from '@assets/icons/calendar.svg';
import dayjs from 'dayjs';

const icon = (
	<Image
		style={{ width: rem(18), height: rem(18) }}
		src={CalendarIcon}
	/>
);

/**
 * Returns the properties for the specified day in the DatePicker calendar.
 * @param {Date} date - The date of the day for which to retrieve the properties.
 * @param {Date} value - The date of the day selected by the user.

 * @returns {Object} The properties of the specified day in the DatePicker calendar, including background style.
 */
export const getDayProps: any = (
	date: Date,
	value: Date
) => {
	if (
		dayjs(date).format('YYYY-MM-DD') ==
			dayjs().format('YYYY-MM-DD') &&
		dayjs(value).format('YYYY-MM-DD') !==
			dayjs().format('YYYY-MM-DD')
	) {
		return {
			style: {
				backgroundColor: '#E4E7FF',
			},
		};
	}

	return {};
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const DatePicker = (props: {
	onChange: (_item: any) => void;
	visibleFrom?: string;
	hiddenFrom?: string;
	label?: string;
	withAsterisk?: boolean;
	disabled?: boolean;
	placeholder?: string;
	size?: any;
	value?: Date;
	clearable?: boolean;
	defaultDate?: Date;
}) => {
	return (
		<DateInput
			valueFormat="DD/MM/YYYY"
			placeholder="Select date"
			leftSection={icon}
			classNames={{
				input: classes.datepicker,
				label: classes.datepickerLabel,
				error: classes.error,
			}}
			defaultDate={props.defaultDate || new Date()}
			getDayProps={(date) =>
				getDayProps(date, props.value)
			}
			minDate={new Date('01/01/1970')}
			{...props}
		/>
	);
};
